var _defs, _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack127({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 4 3.79 7.06 5.4 12 10.6 12 12.21 7.06 8 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack127);
export default __webpack_public_path__ + "static/media/Symbolpack_1_27.8ed14296a59164388026dd6a6f401441.svg";
export { ForwardRef as ReactComponent };